/** localStorage keys shared by shell and Option B satellite SPAs */
export const STORAGE_USER = "weco-user";

/** Dispatched on `window` when `weco-user` is updated in the same tab (storage event does not fire). */
export const WECO_USER_UPDATED_EVENT = "weco-user-updated";
export const STORAGE_ACCESS_TOKEN = "weco-access-token";
export const STORAGE_REFRESH_TOKEN = "weco-refresh-token";
export const STORAGE_THEME = "weco-theme";
export const STORAGE_LOCALE = "weco-locale";
